import { faCss3, faGitAlt, faHtml5, faJsSquare, faLinkedin, faReact } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './About.css';



export const About = () =>{
    return(
        <>
        
        <h2 className="abthead">About Me</h2>     
    <div className="about" id="about">
        <div className="leftabt">   
        <ul>
            <li>MCA Post Graduate, Having Skills of JAVA, Frontend Website
Development With (HTML, CSS, JS, ReactJS)</li><br/>
            <li>Motivated and hardworking individual with a passion for software
development seeks hands-on experience with a team of
professionals. Strong foundation in Java and JavaScript, eager to learn
and grow.</li><br/>
            <li>Willing to have a full-time position in a reputable organization.</li><br/>
        </ul>
        </div>
        <div className="rightabt">
            <div className="stage-cube-cont">
                <div className="cubespinner">
                    <div className="face1">
                        <FontAwesomeIcon icon={faLinkedin} color="#0077B5" />
                    </div>
                    <div className="face2">
                        <FontAwesomeIcon icon={faHtml5} color="F06529" />
                    </div>
                    <div className="face3">
                        <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
                    </div>
                    <div className="face4">
                        <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
                    </div>
                    <div className="face5">
                        <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
                    </div>
                    <div className="face6">
                        <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
)};